export default __webpack_public_path__ + "static/Vertical_Logo_icon_opacity-19348c75af79a624e5baf9dbe4ea6df5.svg";